export default {
  singleLabel: "L'équipe",
  storeNamespace: 'theteam',
  authFeature: 'theteam',
  listRouteName: "TheTeamList",
  newRouteName: "TheTeamNew",
  editRouteName: "TheTeamEdit",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'TheTeamForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'Membre',
  fields: [{
      name: 'intro_text',
      label: "Texte d'intro",
      type: 'wysiwyg',
      allowHtml: true,
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
    },
    {
      name: 'members',
      label: "Membres",
      type: 'group_repeater',
      draggable: true,
      inForm: true,
      fields: [
        {
          name: 'stored_files',
          label: "Photo",
          type: 'file',
          inForm: true,
          inList: false
        },
        {
          name: 'lastname',
          label: "Nom",
          type: 'text',
          inForm: true,
          required: true,
        },
        {
          name: 'firstname',
          label: "Prénom",
          type: 'text',
          inForm: true,
          required: true,
        },
        {
          name: 'function',
          label: "Fonction",
          type: 'text',
          inForm: true,
        },
        {
          name: 'phone_number',
          label: "Téléphone",
          type: 'text',
          inForm: true,
        },
        {
          name: 'email',
          label: "Email",
          type: 'text',
          inForm: true,
        },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/TheTeam/config.js